import { Component } from '@angular/core';

@Component({
    selector: 'app-test-menu-nuevo',
    templateUrl: './test-menu-nuevo.component.html',
    styleUrls: ['./test-menu-nuevo.component.scss'],
})
export class TestMenuNuevoComponent {}
